import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import Tooltip from "@material-ui/core/Tooltip";
import CompanyIcon from "mdi-material-ui/Domain";
import AccountGroupIcon from "mdi-material-ui/AccountGroup";

const useStyles = makeStyles((theme) => ({
  trueCircle: {
    color: theme.palette.secondary.main,
    fontSize: theme.typography.fontSize * 1.25,
    marginRight: theme.spacing(1)
  },
  falseCircle: {
    color: theme.palette.colors.black40,
    fontSize: theme.typography.fontSize * 1.25,
    marginRight: theme.spacing(1)
  }
}));

/**
 * @name FamilyFriendsCell
 * @param {Boolean} value
 * @return {React.Component} A date component
 */
export default function FamilyFriendsCell({ value }) {
  const classes = useStyles();
  const { t } = useTranslation("ns1");

  return (
    <div style={{ display: "flex" }}>
      <Tooltip title={value ? "Ja" : "Nein"}>
        { value ?
          <AccountGroupIcon className={classes.trueCircle}/>
          :
          <CompanyIcon className={classes.falseCircle}/>
        }
      </Tooltip>
    </div>
  );
}

FamilyFriendsCell.propTypes = {
  value: PropTypes.bool
};
